module.exports = __webpack_public_path__ + "static/media/netflix.b99841df.jpg";